// extracted by mini-css-extract-plugin
module.exports = {"feed-rations-body":"feed-rations-body___1tHck"};